import DataRequest from "./DataRequest";
import {useQuery} from "react-query";
import { NotableItem } from "../types/responses/gradingResponse";

export const getNotableItems = (inspectionId: string, user: any) => {
    return useQuery<NotableItem[]>("notableItems", async () => {
        return await DataRequest(inspectionId, "notable-items", user);
    });
}

export const getDefects = (inspectionId: string, user: any) => {
    return useQuery<NotableItem[]>("defects", async () => {
        return await DataRequest(inspectionId, "defects", user);
    });
}
